import { createSignal, createEffect, Show } from "solid-js";
import { Icon } from "@iconify-icon/solid";

import {
  Checkbox,
  CheckboxControl,
} from "@/components/shadcn/checkbox";

import {
  TableCell,
  TableRow,
} from "@/components/shadcn/table";

export const TableViewRow = (props) => {

  const [checked, setChecked] = createSignal(false);

  const onChange = (checked) => {
    props.onToggle(props.key, checked);
  }

  createEffect(() => {
    props.items;
    setChecked(props.items.includes(props.key));
  });

  createEffect(() => {
    props.key;
    setChecked(props.items.includes(props.key));
  });

  return (
    <TableRow>
      <Show when={props.move || props.action}>
        <TableCell width="1%" class="ps-2">
          <div class="text-nowrap" style="height: 100%;">
            <Show when={props.action}>
              <Checkbox class="flex items-center" checked={checked()} onChange={(checked) => onChange(checked)}>
                <CheckboxControl class="border-gray-400 shadow-none me-2" />
              </Checkbox>
            </Show>
            <Show when={props.move}>
              <Icon icon="arrows" />
            </Show>
          </div>
        </TableCell>
      </Show>
      {props.children}
    </TableRow>
  );
}
